import React from 'react';
import { Link } from 'react-router-dom';

const LinkFooter = (props) => (
    <Link to={props.path || '#'} className="footer-list__link">
        {props.title}
    </Link>
);
export default LinkFooter;